export const RESET_SETTINGS_STATE = 'RESET_SETTINGS_STATE';
export const INIT_SETTINGS = 'INIT_SETTINGS';
export const SET_SETTINGS = 'SET_SETTINGS';
export const FETCH_SETTINGS_FAILED = 'FETCH_SETTINGS_FAILED';
export const INIT_SETTINGS_START = 'INIT_SETTINGS_START';
export const CHANGE_NAME_PASS = 'CHANGE_NAME_PASS';
export const REBOOT_ROUTER = 'REBOOT_ROUTER';
export const RESET_ROUTER = 'RESET_ROUTER';
export const OPTIMIZE_ROUTER = 'OPTIMIZE_ROUTER';
export const UPDATE_FIRMWARE = 'UPDATE_FIRMWARE';
export const RUN_SPEED_TEST = 'RUN_SPEED_TEST';
export const GET_SPEED_TEST = 'GET_SPEED_TEST';
export const LOG_SPEED_TEST = 'LOG_SPEED_TEST';
export const GET_FIRMWARE_UPDATE = 'GET_FIRMWARE_UPDATE';
export const GET_FIRMWARE_UPDATE_FAILED = 'GET_FIRMWARE_UPDATE_FAILED';
export const SET_FIRMWARE_UPDATE = 'SET_FIRMWARE_UPDATE';
export const SET_WIN_VERSION = 'SET_WIN_VERSION';
export const SET_FIRMWARE_SPINNER_UPDATE = 'SET_FIRMWARE_SPINNER_UPDATE';
export const GET_FIRMWARE_UPDATE_START = 'GET_FIRMWARE_UPDATE_START';
export const CHECK_FIRMWARE = 'CHECK_FIRMWARE';
export const SET_OPTIMIZE_ROUTER_SPINNER_UPDATE = 'SET_OPTIMIZE_ROUTER_SPINNER_UPDATE';

export const CHANGE_SETTINGS_FAILED = 'CHANGE_SETTINGS_FAILED';
export const CHANGE_SETTINGS_SUCCESS = 'CHANGE_SETTINGS_SUCCESS';
export const SERVICE_RESTORE_SUCCESS = 'SERVICE_RESTORE_SUCCESS';
export const RESET_SETTINGS_ERROR_SUCCESS = 'RESET_SETTINGS_ERROR_SUCCESS';
export const WAIT_FOR_ROUTER = 'WAIT_FOR_ROUTER';
export const ROUTER_READY = 'ROUTER_READY';

export const INIT_GET_ALL = 'INIT_GET_ALL';

export const RESET_EQUIPMENT_STATE = 'RESET_EQUIPMENT_STATE';
export const INIT_EQUIPMENT = 'INIT_EQUIPMENT';
export const SET_EQUIPMENT = 'SET_EQUIPMENT';
export const FETCH_EQUIPMENT_FAILED = 'FETCH_EQUIPMENT_FAILED';
export const INIT_EQUIPMENT_START = 'INIT_EQUIPMENT_START';
export const FETCH_EQUIPMENT_SUCCESS = 'FETCH_EQUIPMENT_SUCCESS';
export const RESET_EQUIPMENT_ERROR_SUCCESS = 'RESET_EQUIPMENT_ERROR_SUCCESS';
export const INIT_SELECTED_EQUIPMENT = 'INIT_SELECTED_EQUIPMENT';
export const SET_SELECTED_EQUIPMENT = 'SET_SELECTED_EQUIPMENT';
export const REBOOT_POD = 'REBOOT_POD';
export const CLAIM_POD = 'CLAIM_POD';
export const CLAIM_POD_FAILED = 'CLAIM_POD_FAILED';
export const RECLAIM_POD = 'RECLAIM_POD';
export const CHANGE_POD = 'CHANGE_POD';
export const CHANGE_POD_FAILED = 'CHANGE_POD_FAILED';
export const CHANGE_POD_SUCCESS = 'CHANGE_POD_SUCCESS';
export const LOCATE_POD = 'LOCATE_POD';
export const LOCATE_ALL_PODS = 'LOCATE_ALL_PODS';
export const LOCATE_POD_SUCCESS = 'LOCATE_POD_SUCCESS';
export const LOCATE_POD_FAILED = 'LOCATE_POD_FAILED';
export const UPDATE_LOCATE_POD = 'UPDATE_LOCATE_POD';
export const CHANGE_EQUIPMENT_NAME_SUCCESS = 'CHANGE_EQUIPMENT_NAME_SUCCESS';
export const CHANGE_EQUIPMENT_NAME_FAILED = 'CHANGE_EQUIPMENT_NAME_FAILED';
export const UPDATE_POD_NAME = 'UPDATE_POD_NAME';

export const RESET_WAN_STATE = 'RESET_WAN_STATE';
export const INIT_WAN = 'INIT_WAN';
export const SET_WAN = 'SET_WAN';
export const SET_TENANT = 'SET_TENANT';
export const FETCH_WAN_FAILED = 'FETCH_WAN_FAILED';
export const INIT_WAN_START = 'INIT_WAN_START';
export const RESTARTING = 'RESTARTING';
export const POD_RESTARTING = 'POD_RESTARTING';
export const CHECK_WAN = 'CHECK_WAN';
export const WAN_CONNECTED = 'WAN_CONNECTED';
export const RUN_WIFI_SERVICE_CHECK = 'RUN_WIFI_SERVICE_CHECK';
export const WAN_WIFI_SERVICE_CHECK_TIMER = 'WAN_WIFI_SERVICE_CHECK_TIMER';
export const FETCH_WSC_FAILED = 'FETCH_WSC_FAILED';

export const INIT_CONNECTIVITY = 'INIT_CONNECTIVITY';
export const SET_CONNECTIVITY = 'SET_CONNECTIVITY';
export const FETCH_CONNECTIVITY_FAILED = 'FETCH_CONNECTIVITY_FAILED';
export const INIT_CONNECTIVITY_START = 'INIT_CONNECTIVITY_START';


export const SET_SPECTRUM_STATUS = 'SET_SPECTRUM_STATUS';
export const GET_SPECTRUM_STATUS_FAILED = 'GET_SPECTRUM_STATUS_FAILED';
export const INIT_SPECTRUM_STATUS = 'INIT_SPECTRUM_STATUS';
export const INIT_SPECTRUM_STATUS_START = 'INIT_SPECTRUM_STATUS_START';

export const MOVE_IN = 'MOVE_IN';
export const MOVE_OUT = 'MOVE_OUT';
export const SHOW_SIDE_MENU = 'SHOW_SIDE_MENU';
export const DONT_SHOW_SIDE_MENU = 'DONT_SHOW_SIDE_MENU';


export const RESET_MANAGED_STATE = 'RESET_MANAGED_STATE';
export const INIT_MANAGED = 'INIT_MANAGED';
export const SET_MANAGED = 'SET_MANAGED';
export const FETCH_MANAGED_FAILED = 'FETCH_MANAGED_FAILED';
export const INIT_MANAGED_START = 'INIT_MANAGED_START';


export const RESET_DEVICES_STATE = 'RESET_DEVICES_STATE';
export const INIT_DEVICES = 'INIT_DEVICES';
export const SET_DEVICES = 'SET_DEVICES';
export const SET_DEVICES_BY_EQUIPMENT = 'SET_DEVICES_BY_EQUIPMENT';
export const FETCH_DEVICES_FAILED = 'FETCH_DEVICES_FAILED';
export const INIT_DEVICES_START = 'INIT_DEVICES_START';
export const CHANGE_DEVICE_NAME = 'CHANGE_DEVICE_NAME';
export const CHANGE_DEVICE_ICON = 'CHANGE_DEVICE_ICON';
export const CHANGE_PAUSE_DEVICE = 'CHANGE_PAUSE_DEVICE';
export const CHANGE_FREEZE_DEVICE = 'CHANGE_FREEZE_DEVICE';
export const DELETE_DEVICE = 'DELETE_DEVICE';
export const CHANGE_DEVICES_FAILED = 'CHANGE_DEVICES_FAILED';
export const CHANGE_DEVICES_SUCCESS = 'CHANGE_DEVICES_SUCCESS';
export const RESET_DEVICES_ERROR_SUCCESS = 'RESET_DEVICES_ERROR_SUCCESS';
export const REFRESH_DEVICES = 'REFRESH_DEVICES';
export const GET_ADVANCED_DEVICE_START = 'GET_ADVANCED_DEVICE_START';
export const GET_ADVANCED_IDS_START = 'GET_ADVANCED_IDS_START';
export const GET_ADVANCED_DEVICE = 'GET_ADVANCED_DEVICE';
export const SET_ADVANCED_DEVICE = 'SET_ADVANCED_DEVICE';
export const GET_ADVANCED_DEVICE_IDS = 'GET_ADVANCED_DEVICE_IDS';
export const SET_ADVANCED_DEVICE_IDS = 'SET_ADVANCED_DEVICE_IDS';
export const REPORT_ADID_ISSUE = 'REPORT_ADID_ISSUE';
export const REPORT_ADID_ISSUE_SUCCESS = 'REPORT_ADID_ISSUE_SUCCESS';
export const REPORT_ADID_ISSUE_FAILED = 'REPORT_ADID_ISSUE_FAILED';
export const RESET_ADID_ISSUE_ERROR_SUCCESS = 'RESET_ADID_ISSUE_ERROR_SUCCESS';
export const DELETE_DEVICE_FREEZES = 'DELETE_DEVICE_FREEZES';
export const ACTIVITY_SELECTED_DEVICE_DETAILS = 'ACTIVITY_SELECTED_DEVICE_DETAILS';

export const RESET_DEVICE_GROUPS_STATE = 'RESET_DEVICE_GROUPS_STATE';
export const INIT_DEVICE_GROUPS_START = 'INIT_DEVICE_GROUPS_START';
export const INIT_DEVICE_GROUPS = 'INIT_DEVICE_GROUPS';
export const SET_DEVICE_GROUPS = 'SET_DEVICE_GROUPS';
export const FETCH_DEVICE_GROUPS_FAILED = 'FETCH_DEVICE_GROUPS_FAILED';
export const CHANGE_DEVICE_GROUP_DETAILS = 'CHANGE_DEVICE_GROUP_DETAILS';
export const CHANGE_DEVICES_GROUP_FAILED = 'CHANGE_DEVICES_GROUP_FAILED';
export const CHANGE_DEVICES_GROUP_SUCCESS = 'CHANGE_DEVICES_GROUP_SUCCESS';
export const PAUSE_DEVICE_GROUP = 'PAUSE_DEVICE_GROUP';
export const PAUSE_DEVICE_GROUP_FAILED = 'PAUSE_DEVICE_GROUP_FAILED';
export const PAUSE_DEVICE_GROUP_SUCCESS = 'PAUSE_DEVICE_GROUP_SUCCESS';
export const RESET_PAUSE_DEVICE_GROUP_SUCCESS_ERROR = 'RESET_PAUSE_DEVICE_GROUP_SUCCESS_ERROR';
export const RESET_GROUPS_ERROR_SUCCESS = 'RESET_GROUPS_ERROR_SUCCESS';
export const CREATE_DEVICE_GROUP_START = 'CREATE_DEVICE_GROUP_START';
export const CREATE_DEVICE_GROUP = 'CREATE_DEVICE_GROUP';
export const CREATE_DEVICE_GROUP_FAILED = 'CREATE_DEVICE_GROUP_FAILED';
export const CREATE_DEVICE_GROUP_SUCCESS = 'CREATE_DEVICE_GROUP_SUCCESS';
export const CREATE_GROUP_PAUSE_SCHEDULE = 'CREATE_GROUP_PAUSE_SCHEDULE';
export const DELETE_GROUP_PAUSE_SCHEDULE = 'DELETE_GROUP_PAUSE_SCHEDULE';
export const RESET_CREATE_DEVICE_GROUP_SUCCESS_ERROR = 'RESET_CREATE_DEVICE_GROUP_SUCCESS_ERROR';
export const GET_DEVICES_FROM_GROUP_START = 'GET_DEVICES_FROM_GROUP_START';
export const GET_DEVICES_FROM_GROUP = 'GET_DEVICES_FROM_GROUP';
export const GET_DEVICES_FROM_GROUP_FAILED = 'GET_DEVICES_FROM_GROUP_FAILED';
export const FREEZE_DEVICE_GROUP = 'FREEZE_DEVICE_GROUP';
export const FREEZE_DEVICE_GROUP_SUCCESS = 'FREEZE_DEVICE_GROUP_SUCCESS';
export const FREEZE_DEVICE_GROUP_FAILED = 'FREEZE_DEVICE_GROUP_FAILED';



export const RESET_DHCP_STATE = 'RESET_DHCP_STATE';
export const INIT_DHCP = 'INIT_DHCP';
export const SET_DHCP = 'SET_DHCP';
export const FETCH_DHCP_FAILED = 'FETCH_DHCP_FAILED';
export const INIT_DHCP_START = 'INIT_DHCP_START';
export const ADD_PORT_ASSIGNMENT = 'ADD_PORT_ASSIGNMENT';
export const CHANGE_PORT_ASSIGNMENT = 'CHANGE_PORT_ASSIGNMENT';
export const DELETE_PORT_ASSIGNMENT = 'DELETE_PORT_ASSIGNMENT';
export const ADD_IP_RESERVATION = 'ADD_IP_RESERVATION';
export const DELETE_IP_RESERVATION = 'DELETE_IP_RESERVATION';
export const CHANGE_DHCP_FAILED = 'CHANGE_DHCP_FAILED';
export const CHANGE_DHCP_SUCCESS = 'CHANGE_DHCP_SUCCESS';
export const RESET_DHCP_ERROR_SUCCESS = 'RESET_DHCP_ERROR_SUCCESS';

export const RESET_DNS_STATE = 'RESET_DNS_STATE';
export const INIT_DNS = 'INIT_DNS';
export const SET_DNS = 'SET_DNS';
export const FETCH_DNS_FAILED = 'FETCH_DNS_FAILED';
export const INIT_DNS_START = 'INIT_DNS_START';
export const CHANGE_DNS = 'CHANGE_DNS';
export const CHANGE_DNS_FAILED = 'CHANGE_DNS_FAILED';
export const CHANGE_DNS_SUCCESS = 'CHANGE_DNS_SUCCESS';
export const RESET_DNS_ERROR_SUCCESS = 'RESET_DNS_ERROR_SUCCESS';

export const RESET_UPNP_STATE = 'RESET_UPNP_STATE';
export const INIT_UPNP = 'INIT_UPNP';
export const SET_UPNP = 'SET_UPNP';
export const FETCH_UPNP_FAILED = 'FETCH_UPNP_FAILED';
export const INIT_UPNP_START = 'INIT_UPNP_START';
export const CHANGE_UPNP = 'CHANGE_UPNP';
export const CHANGE_UPNP_FAILED = 'CHANGE_UPNP_FAILED';
export const CHANGE_UPNP_SUCCESS = 'CHANGE_UPNP_SUCCESS';
export const RESET_UPNP_ERROR_SUCCESS = 'RESET_UPNP_ERROR_SUCCESS';

export const INIT_MOBILE_HOME = 'INIT_MOBILE_HOME';
export const SET_MOBILE_HOME = 'SET_MOBILE_HOME';
export const FETCH_MOBILE_HOME_FAILED = 'FETCH_MOBILE_HOME_FAILED';
export const INIT_MOBILE_HOME_START = 'INIT_MOBILE_HOME_START';
export const CHANGE_MOBILE_HOME = 'CHANGE_MOBILE_HOME';
export const CHANGE_MOBILE_HOME_FAILED = 'CHANGE_MOBILE_HOME_FAILED';
export const CHANGE_MOBILE_HOME_SUCCESS = 'CHANGE_MOBILE_HOME_SUCCESS';
export const RESET_MOBILE_HOME_ERROR_SUCCESS = 'RESET_MOBILE_HOME_ERROR_SUCCESS';

export const RESET_TOPOLOGY_STATE = 'RESET_TOPOLOGY_STATE';
export const INIT_TOPOLOGY = 'INIT_TOPOLOGY';
export const SET_TOPOLOGY = 'SET_TOPOLOGY';
export const FETCH_TOPOLOGY_FAILED = 'FETCH_TOPOLOGY_FAILED';
export const INIT_TOPOLOGY_START = 'INIT_TOPOLOGY_START';


export const RESET_BANDWIDTH_STATE = 'RESET_BANDWIDTH_STATE';
export const INIT_BANDWIDTH = 'INIT_BANDWIDTH';
export const SET_BANDWIDTH = 'SET_BANDWIDTH';
export const FETCH_BANDWIDTH_FAILED = 'FETCH_BANDWIDTH_FAILED';
export const INIT_BANDWIDTH_START = 'INIT_BANDWIDTH_START';


export const RESET_LOGS_STATE = 'RESET_LOGS_STATE';
export const INIT_LOGS = 'INIT_LOGS';
export const GET_ONE_LOG = 'GET_ONE_LOG';
export const GET_ONE_LOG_FAIL = 'GET_ONE_LOG_FAIL';
export const GET_ONE_LOG_START = 'GET_ONE_LOG_START';
export const SET_LOGS = 'SET_LOGS';
export const SET_LOG_LINK = 'SET_LOG_LINK';
export const SET_ACTIVE_LOG = 'SET_ACTIVE_LOG';
export const SET_FROM_LOG_DETAILS_PAGE = 'SET_FROM__LOG_DETAILS_PAGE';
export const FETCH_LOGS_FAILED = 'FETCH_LOGS_FAILED';
export const FETCH_LOG_LINK_FAILED = 'FETCH_LOG_LINK_FAILED';
export const INIT_LOGS_START = 'INIT_LOGS_START';
export const ADD_LOGS = 'ADD_LOGS';
export const ADD_LOGS_SUCCESS = 'ADD_LOGS_SUCCESS';
export const ADD_LOGS_FAIL = 'ADD_LOGS_FAIL';
export const ADD_LOGS_START = 'ADD_LOGS_START';
export const ADD_LOGS_INIT = 'ADD_LOGS_INIT';
export const EDIT_LOGS_START = 'EDIT_LOGS_START';
export const EDIT_LOGS_SUCCESS = 'EDIT_LOGS_SUCCESS';
export const EDIT_LOGS_FAIL = 'EDIT_LOGS_FAIL';
export const EDIT_LOGS = 'EDIT_LOGS';
export const DELETE_LOGS = 'DELETE_LOGS';
export const GET_LOG_LINK = 'GET_LOG_LINK';
export const INIT_LOG_LINK_START = 'INIT_LOG_LINK_START';

export const INIT_SB_LOGS = 'INIT_SB_LOGS';
export const SET_SB_LOGS = 'SET_SB_LOGS';
export const FETCH_SB_LOGS_FAILED = 'FETCH_SB_LOGS_FAILED';
export const INIT_SB_LOGS_START = 'INIT_SB_LOGS_START';

export const RESET_SPEED_BOOST_STATE = 'RESET_SPEED_BOOST_STATE';
export const DEVICES_GET_SPEED_BOOST = 'DEVICES_GET_SPEED_BOOST';
export const DEVICES_GET_SPEED_BOOST_LOADING = 'DEVICES_GET_SPEED_BOOST_LOADING';
export const DEVICES_GET_SPEED_BOOST_SUCCESS = 'DEVICES_GET_SPEED_BOOST_SUCCESS';
export const DEVICES_GET_SPEED_BOOST_FAILURE = 'DEVICES_GET_SPEED_BOOST_FAILURE';

export const INIT_USERS = 'INIT_USERS';
export const GET_ONE_USER = 'GET_ONE_USER';
export const GET_ONE_USER_FAIL = 'GET_ONE_USER_FAIL';
export const GET_ONE_USER_START = 'GET_ONE_USER_START';
export const SET_USERS = 'SET_USERS';
export const SET_ACTIVE_USER = 'SET_ACTIVE_USER';
export const SET_FROM_USER_DETAILS_PAGE = 'SET_FROM_USER__DETAILS_PAGE';
export const FETCH_USERS_FAILED = 'FETCH_USERS_FAILED';
export const INIT_USERS_START = 'INIT_USERS_START';
export const ADD_USERS = 'ADD_USERS';
export const ADD_USERS_SUCCESS = 'ADD_USERS_SUCCESS';
export const ADD_USERS_FAIL = 'ADD_USERS_FAIL';
export const ADD_USERS_START = 'ADD_USERS_START';
export const ADD_USERS_INIT = 'ADD_USERS_INIT';
export const EDIT_USERS_START = 'EDIT_USERS_START';
export const EDIT_USERS_SUCCESS = 'EDIT_USERS_SUCCESS';
export const EDIT_USERS_FAIL = 'EDIT_USERS_FAIL';
export const EDIT_USERS = 'EDIT_USERS';
export const DELETE_USERS = 'DELETE_USERS';

export const AUTH_CHECK_STATE = 'AUTH_CHECK_STATE';
export const AUTH_USER = 'AUTH_USER';
export const AUTH_TOKEN = 'AUTH_TOKEN';
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const START_APP = 'START_APP';
export const AUTH_CHECK_TIMEOUT = 'AUTH_CHECK_TIMEOUT';
export const AUTH_INITIATE_LOGOUT = 'AUTH_INITIATE_LOGOUT';

export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const PINXT_CHECK_STATE = 'PINXT_CHECK_STATE';
export const PINXT_TRY = 'PINXT_TRY';
export const PINXT_START = 'PINXT_START';
export const PINXT_SUCCESS = 'PINXT_SUCCESS';
export const PINXT_FAIL = 'PINXT_FAIL';
export const PINXT_CHECK_TIMEOUT = 'PINXT_CHECK_TIMEOUT';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';
export const TOGGLE_IS_DUMMY = 'TOGGLE_IS_DUMMY';

export const DELETE_GROUPS_SUCCESS = 'DELETE_GROUPS_SUCCESS';
export const DELETE_GROUPS_FAILED = 'DELETE_GROUPS_FAILED';
export const DELETE_GROUPS = 'DELETE_GROUPS';

export const UNASSIGN_DEVICE_GROUPS = 'UNASSIGN_DEVICE_GROUPS';
export const UNASSIGN_DEVICE_GROUPS_SUCCESS = 'UNASSIGN_DEVICE_GROUPS_SUCCESS';
export const UNASSIGN_DEVICE_GROUPS_FAILED = 'UNASSIGN_DEVICE_GROUPS_FAILED';
export const RESET_GROUP_DEVICE_SUCCESS_ERROR = 'RESET_GROUP_DEVICE_SUCCESS_ERROR';

export const RESET_MULTI_ADVANCED_WIFI_STATE = 'RESET_MULTI_ADVANCED_WIFI_STATE';
export const CREATE_MULTIADVANCEDWIFI = 'CREATE_MULTIADVANCEDWIFI';
export const CREATE_MULTIADVANCEDWIFI_FAILED = 'CREATE_MULTIADVANCEDWIFI_FAILED';
export const CREATE_MULTIADVANCEDWIFI_SUCCESS = 'CREATE_MULTIADVANCEDWIFI_SUCCESS';
export const RESET_MULTIADVANCEDWIFI_ERROR_SUCCESS = 'RESET_MULTIADVANCEDWIFI_ERROR_SUCCESS';
export const INIT_MULTIADVANCEDWIFI = 'INIT_MULTIADVANCEDWIFI';
export const GET_ENTITLEMENT = 'GET_ENTITLEMENT';
export const GET_ENTITLEMENT_SUCCESS = 'GET_ENTITLEMENT_SUCCESS';
export const GET_ENTITLEMENT_FAILED = 'GET_ENTITLEMENT_FAILED';
export const DELETE_MULTIADVANCEDWIFI = 'DELETE_MULTIADVANCEDWIFI';
export const DELETE_MULTIADVANCEDWIFI_SUCCESS = 'DELETE_MULTIADVANCEDWIFI_SUCCESS';
export const DELETE_MULTIADVANCEDWIFI_FAILED = 'DELETE_MULTIADVANCEDWIFI_FAILED';
export const GET_MULTIROUTER_BY_SOLOID = 'GET_MULTIROUTER_SOLOID';
export const GET_MULTIROUTER_BY_SOLOID_SUCCESS = 'GET_MULTIROUTER_BY_SOLOID_SUCCESS';
export const GET_MULTIROUTER_BY_SOLOID_FAILED = 'GET_MULTIROUTER_BY_SOLOID_FAILED';

// MultiRouter
export const INIT_MULTI_ROUTER_START = 'INIT_MULTI_ROUTER_START';
export const GET_MULTI_ROUTER = 'GET_MULTI_ROUTER';
export const SET_MULTI_ROUTER = 'SET_MULTI_ROUTER';
export const GET_MULTI_ROUTER_FAILED = 'GET_MULTI_ROUTER_FAILED';
export const GET_MULTI_ROUTER_SUCCESS = 'GET_MULTI_ROUTER_SUCCESS';
export const ASSIGN_POD_REQUEST = 'ASSIGN_POD_REQUEST';
export const ASSIGN_POD = 'ASSIGN_POD';
export const ASSIGN_POD_SUCCESS = 'ASSIGN_POD_SUCCESS';
export const ASSIGN_POD_FAILED = 'ASSIGN_POD_FAILED';
export const UNCLAIMED_POD_REQUEST = 'UNCLAIMED_POD_REQUEST';
export const UNCLAIMED_POD = 'UNCLAIMED_POD';
export const UNCLAIMED_POD_SUCCESS = 'UNCLAIMED_POD_SUCCESS';
export const UNCLAIMED_POD_FAILED = 'UNCLAIMED_POD_FAILED';
export const RESET_MULTI_ROUTER_STATUS = 'RESET_MULTI_ROUTER_STATUS'


// Advance Security
export const RESET_ADVANCED_SECURITY_STATE = 'RESET_ADVANCED_SECURITY_STATE';
export const GET_ADVANCED_SECURITY_START = 'GET_ADVANCED_SECURITY_START';
export const ADVANCED_SECURITY_HANDLER = 'ADVANCED_SECURITY_HANDLER';
export const SET_ADVANCED_SECURITY = 'SET_ADVANCED_SECURITY';
export const SET_ADVANCED_SECURITY_SUCCESS = 'SET_ADVANCED_SECURITY_SUCCESS';
export const SET_ADVANCED_SECURITY_FAILED = 'SET_ADVANCED_SECURITY_FAILED';

// Security Threats
export const RESET_SECURITY_THREATS_STATE = 'RESET_SECURITY_THREATS_STATE';
export const GET_ADVANCED_SECURITY_THREATS = 'GET_ADVANCED_SECURITY_THREATS';
export const GET_SECURITY_THREATS_START = 'GET_SECURITY_THREATS_START';
export const SET_SECURITY_LOG_INFO = 'SET_SECURITY_LOG_INFO';
export const INIT_SECURITY_LOG_INFO = 'INIT_SECURITY_LOG_INFO';
export const SET_ADVANCED_SECURITY_THREATS = 'SET_ADVANCED_SECURITY_THREATS';
export const SET_ADVANCED_SECURITY_THREATS_SUCCESS = 'SET_ADVANCED_SECURITY_THREATS_SUCCESS';
export const SET_ADVANCED_SECURITY_THREATS_FAILED = 'SET_ADVANCED_SECURITY_THREATS_FAILED';
export const SET_ADVANCED_SECURITY_THREATS_REFRESH = 'SET_ADVANCED_SECURITY_THREATS_REFRESH';

// Property Manager
export const GET_PROPERTY_MANAGER_DETAILS = 'GET_PROPERTY_MANAGER_DETAILS';
export const SET_PROPERTY_MANAGER_DETAILS = 'SET_PROPERTY_MANAGER_DETAILS';
export const SET_PROPERTY_MANAGER_SUCCESS = 'SET_PROPERTY_MANAGER_SUCCESS';
export const SET_PROPERTY_MANAGER_FAILED = 'SET_PROPERTY_MANAGER_FAILED';
export const INIT_PROPERTY_MANAGER_START = 'INIT_PROPERTY_MANAGER_START';
export const INIT_PROPERTY_MANAGER_TENANT_DETAILS_START = 'INIT_PROPERTY_MANAGER_TENANT_DETAILS_START';
export const GET_PROPERTY_MANAGER_TENANT_DETAILS = 'GET_PROPERTY_MANAGER_TENANT_DETAILS';
export const SET_PROPERTY_MANAGER_TENANT_DETAILS = 'SET_PROPERTY_MANAGER_TENANT_DETAILS';
export const SET_PROPERTY_MANAGER_TENANT_DETAILS_SUCCESS = 'SET_PROPERTY_MANAGER_TENANT_DETAILS_SUCCESS';
export const SET_PROPERTY_MANAGER_TENANT_DETAILS_FAILED = 'SET_PROPERTY_MANAGER_TENANT_DETAILS_FAILED';
export const RESTORE_SERVICE_TENANT_ACCOUNT = 'RESTORE_SERVICE_TENANT_ACCOUNT';
export const RESTORE_SERVICE_TENANT_ACCOUNT_SUCCESS = 'RESTORE_SERVICE_TENANT_ACCOUNT_SUCCESS';
export const RESTORE_SERVICE_TENANT_ACCOUNT_FAILED = 'RESTORE_SERVICE_TENANT_ACCOUNT_FAILED';
export const RESUME_SPEC_READY_SERVICE_TENANT_ACCOUNT = 'RESUME_SPEC_READY_SERVICE_TENANT_ACCOUNT';
export const RESET_PROPERTY_MANAGER_FLAGS = 'RESET_PROPERTY_MANAGER_FLAGS';

// IOT Network
export const CREATE_IOT_SSID_NETWORK = 'CREATE_IOT_SSID_NETWORK';
export const CREATE_IOT_SSID_NETWORK_LOADING = 'CREATE_IOT_SSID_NETWORK_LOADING';
export const CREATE_IOT_SSID_NETWORK_SUCCESS = 'CREATE_IOT_SSID_NETWORK_SUCCESS';
export const CREATE_IOT_SSID_NETWORK_FAILED = 'CREATE_IOT_SSID_NETWORK_FAILED';
export const GET_IOT_SSID_NETWORK_DETAILS = 'GET_IOT_SSID_NETWORK_DETAILS';
export const GET_IOT_SSID_NETWORK_LOADING = 'GET_IOT_SSID_NETWORK_LOADING';
export const GET_IOT_SSID_NETWORK_SUCCESS = 'GET_IOT_SSID_NETWORK_SUCCESS';
export const GET_IOT_SSID_NETWORK_FAILED = 'GET_IOT_SSID_NETWORK_FAILED';
export const GET_ALL_IOT_SSID_NETWORK_DETAILS = 'GET_ALL_IOT_SSID_NETWORK_DETAILS';
export const GET_ALL_IOT_SSID_NETWORK_DETAILS_LOADING = 'GET_ALL_IOT_SSID_NETWORK_DETAILS_LOADING';
export const GET_IOT_NETWORK_DEVICES = 'GET_IOT_NETWORK_DEVICES';
export const GET_IOT_SSID_NETWORK_DEVICES_FAILED = 'GET_IOT_SSID_NETWORK_DEVICES_FAILED';
export const GET_IOT_SSID_NETWORK_DEVICES_SUCCESS = 'GET_IOT_SSID_NETWORK_DEVICES_SUCCESS';
export const RESET_IOT_SSID_ERROR_SUCCESS = 'RESET_IOT_SSID_ERROR_SUCCESS';



// Router Speed Check
// export const GET_RSC_IS_AVAILABLE = 'GET_RSC_IS_AVAILABLE'
export const SET_RSC_IS_AVAILABLE = 'SET_RSC_IS_AVAILABLE'
export const GET_RSC_START_TIME = 'GET_RSC_START_TIME'
export const SET_RSC_START_TIME = 'SET_RSC_START_TIME'
export const GET_RSC_RESULTS = 'GET_RSC_RESULTS'
export const SET_RSC_RESULTS_SUCCESS = 'SET_RSC_RESULTS_SUCCESS'
export const SET_RSC_RESULTS_FAILED = 'SET_RSC_RESULTS_FAILED'
export const STOP_RSC_POLLING = 'STOP_RSC_POLLING'
export const RESET_RSC_FLAGS = 'RESET_RSC_FLAGS'
export const SET_RESULTS_LOADING = 'SET_RESULTS_LOADING'
export const SET_RESULTS_LOADED = 'SET_RESULTS_LOADED'

// Device Steering
export const START_DEVICE_STEERING_POLLING = 'START_DEVICE_STEERING_POLLING';
export const SET_STEERING_EXPIRES_AT = 'SET_STEERING_EXPIRES_AT';
export const DEVICE_STEERING_PUT_DELETE = 'DEVICE_STEERING_PUT_DELETE';
export const DEVICE_STEERING_PUT_DELETE_LOADING = 'DEVICE_STEERING_PUT_DELETE_LOADING';
export const DEVICE_STEERING_PUT_DELETE_SUCCESS = 'DEVICE_STEERING_PUT_DELETE_SUCCESS';
export const DEVICE_STEERING_PUT_DELETE_FAILED = 'DEVICE_STEERING_PUT_DELETE_FAILED';
export const RESET_DEVICE_STEERING_FLAGS = 'RESET_DEVICE_STEERING_FLAGS';
export const GET_DEVICE_STEERING = 'GET_DEVICE_STEERING';
export const GET_DEVICE_STEERING_LOADING = 'GET_DEVICE_STEERING_LOADING';
export const GET_DEVICE_STEERING_SUCCESS = 'GET_DEVICE_STEERING_SUCCESS';
export const GET_DEVICE_STEERING_FAILED = 'GET_DEVICE_STEERING_FAILED';
export const STOP_DEVICE_STEERING_POLLING = 'STOP_DEVICE_STEERING_POLLING';
export const DEVICE_STEERING_START_TIME = 'DEVICE_STEERING_START_TIME';
export const STOP_DEVICE_STEERING = 'STOP_DEVICE_STEERING';
export const START_DEVICE_STERING_ALL_POLLING = 'START_DEVICE_STEERING_ALL_POLLING';
export const RESET_DEVICES_STEERING_ERROR_SUCCESS = 'RESET_DEVICES_STEERING_ERROR_SUCCESS';
export const  START_DEVICE_STERING_ALL_POLLING_SUCCESS = 'START_DEVICE_STERING_ALL_POLLING_SUCCESS';
export const START_DEVICE_STERING_ALL_POLLING_FAILED = 'START_DEVICE_STERING_ALL_POLLING_FAILED';
export const START_DEVICE_STERING_ALL_POLLING_LOADING = 'START_DEVICE_STERING_ALL_POLLING_LOADING';

// QoE
export const GET_HISTORICAL_QOE_METRICS = 'GET_HISTORICAL_QOE_METRICS';
export const GET_QOE_SCORES = 'GET_QOE_SCORES';
export const GET_QOE_SCORES_SUCCESS = 'GET_QOE_SCORES_SUCCESS';
export const GET_QOE_SCORES_FAILED = 'GET_QOE_SCORES_FAILED';
export const GET_QOE_SUCCESS = 'GET_QOE_SUCCESS';
export const GET_QOE_FAILED = 'GET_QOE_FAILED';
export const GET_QOE_FAILED_RESET = 'GET_QOE_FAILED_RESET';
export const LOG_QOE_RESULTS = 'LOG_QOE_RESULTS';

// Port Forwardings
export const FETCH_PORT_FORWARDING = 'FETCH_PORT_FORWARDING'
export const SET_PORT_FORWARDING_START_TIME = 'SET_PORT_FORWARDING_START_TIME';
export const SET_PORT_FORWARDING_SUCCESS = 'SET_PORT_FORWARDING_SUCCESS';
export const SET_PORT_FORWARDING_FAIL = 'SET_PORT_FORWARDING_FAIL';
export const GET_DHCP_RESERVATIONS = 'GET_DHCP_RESERVATIONS';
export const GET_DHCP_RESERVATIONS_LOADING = 'GET_DHCP_RESERVATIONS_LOADING';
export const GET_DHCP_RESERVATIONS_SUCCESS = 'GET_DHCP_RESERVATIONS_SUCCESS';
export const GET_DHCP_RESERVATIONS_FAIL = 'GET_DHCP_RESERVATIONS_FAIL';
export const SET_DHCP_ERROR = 'SET_DHCP_ERROR';
export const SET_NEW_DHCP_RESERVATIONS = 'SET_NEW_DHCP_RESERVATIONS';
export const SET_NEW_DHCP_RESERVATIONS_LOADING = 'SET_NEW_DHCP_RESERVATIONS_LOADING';
export const SET_NEW_DHCP_RESERVATIONS_SUCCESS = 'SET_NEW_DHCP_RESERVATIONS_SUCCESS';
export const SET_NEW_DHCP_RESERVATIONS_FAIL = 'SET_NEW_DHCP_RESERVATIONS_FAIL';


// Second SSID
export const GET_SECOND_SSID = 'GET_SECOND_SSID';
export const GET_SECOND_SSID_LOADING = 'GET_SECOND_SSID_LOADING';
export const GET_SECOND_SSID_SUCCESS = 'GET_SECOND_SSID_SUCCESS';
export const GET_SECOND_SSID_FAIL = 'GET_SECOND_SSID_FAIL';
export const ADD_SECOND_SSID_INFO = 'ADD_SECOND_SSID_INFO';
export const SET_SECOND_SSID_INFO = 'SET_SECOND_SSID_INFO';
export const SET_SECOND_SSID_INFO_SUCCESS = 'SET_SECOND_SSID_INFO_SUCCESS';
export const SET_SECOND_SSID_INFO_FAIL = 'SET_SECOND_SSID_INFO_FAIL';
export const SET_SECOND_SSID_INFO_FAIL_MESSAGE = 'SET_SECOND_SSID_INFO_FAIL_MESSAGE';
export const RESET_SECOND_SSID_ERROR_SUCCESS = 'RESET_SECOND_SSID_ERROR_SUCCESS';
export const DELETE_SECOND_SSID_INFO = 'DELETE_SECOND_SSID_INFO';
export const DELETE_SECOND_SSID_INFO_SUCCESS = 'DELETE_SECOND_SSID_INFO_SUCCESS';
export const DELETE_SECOND_SSID_INFO_FAILED = 'DELETE_SECOND_SSID_INFO_FAILED';

// Upstream Error
export const SET_UPSTREAM_ERROR = 'SET_UPSTREAM_ERROR';
export const RESET_UPSTREAM_ERROR = 'RESET_UPSTREAM_ERROR';

//STATIC IP'S
export const GET_STATIC_IP = 'GET_STATIC_IP';
export const GET_STATIC_IP_SUCCESS = 'GET_STATIC_IP_SUCCESS';
export const GET_STATIC_IP_FAIL = 'GET_STATIC_IP_FAIL';
export const GET_STATIC_IP_LOADING = 'GET_STATIC_IP_LOADING';
export const SET_STATIC_IP = 'SET_STATIC_IP';
export const SET_STATIC_IP_SUCCESS = 'SET_STATIC_IP_SUCCESS';
export const SET_STATIC_IP_FAIL = 'SET_STATIC_IP_FAIL';
export const SET_STATIC_IP_LOADING = 'SET_STATIC_IP_LOADING';
export const SET_STATIC_IP_FAIL_MESSAGE = 'SET_STATIC_IP_FAIL_MESSAGE';
export const RESET_STATIC_IP_ERROR_SUCCESS = 'RESET_STATIC_IP_ERROR_SUCCESS';
export const DELETE_STATIC_IP_INFO = 'DELETE_STATIC_IP_INFO';
export const DELETE_STATIC_IP_INFO_SUCCESS = 'DELETE_STATIC_IP_INFO_SUCCESS';
export const DELETE_STATIC_IP_INFO_FAILED = 'DELETE_STATIC_IP_INFO_FAILED';

//WIFI Security Protocal
export const WIFI_SECURITY_CHANGE_ALL = 'WIFI_SECURITY_CHANGE_ALL';
export const SET_WIFI_SECURITY_BAND = 'SET_WIFI_SECURITY_BAND';
export const SET_WIFI_SECURITY_FAIL = 'SET_WIFI_SECURITY_FAIL';
export const SET_WIFI_SECURITY_SUCCESS = 'SET_WIFI_SECURITY_SUCCESS';
export const WIFI_SECURITY_CHANGE_LOADING = 'WIFI_SECURITY_CHANGE_LOADING';
export const GET_ALL_WIFI_SECURITY_SUMMARY = 'GET_ALL_WIFI_SECURITY_SUMMARY';
export const GET_ALL_WIFI_SECURITY_SUMMARY_SUCCESS = 'GET_ALL_WIFI_SECURITY_SUMMARY_SUCCESS';
export const GET_ALL_WIFI_SECURITY_SUMMARY_FAIL = 'GET_ALL_WIFI_SECURITY_SUMMARY_FAIL';
export const GET_ALL_WIFI_SECURITY_SUMMARY_LOADING = 'GET_ALL_WIFI_SECURITY_SUMMARY_LOADING';


// Guest Network
export const GET_GUEST_NETWORK_SESSION = 'GET_GUEST_NETWORK_SESSION';
export const GET_GUEST_NETWORK_SESSION_LOADING = 'GET_GUEST_NETWORK_SESSION_LOADING';
export const GET_GUEST_NETWORK_SESSION_SUCCESS = 'GET_GUEST_NETWORK_SESSION_SUCCESS';
export const GET_GUEST_NETWORK_SESSION_FAIL = 'GET_GUEST_NETWORK_SESSION_FAIL';
export const UPDATE_GUEST_NETWORK_SESSION = 'UPDATE_GUEST_NETWORK_SESSION';
export const UPDATE_GUEST_NETWORK_SESSION_LOADING = 'UPDATE_GUEST_NETWORK_SESSION_LOADING';
export const UPDATE_GUEST_NETWORK_SESSION_SUCCESS = 'UPDATE_GUEST_NETWORK_SESSION_SUCCESS';
export const UPDATE_GUEST_NETWORK_SESSION_FAIL = 'UPDATE_GUEST_NETWORK_SESSION_FAIL';
export const GET_GUEST_NETWORK_SCHEDULE = 'GET_GUEST_NETWORK_SCHEDULE';
export const GET_GUEST_NETWORK_SCHEDULE_LOADING = 'GET_GUEST_NETWORK_SCHEDULE_LOADING';
export const GET_GUEST_NETWORK_SCHEDULE_SUCCESS = 'GET_GUEST_NETWORK_SCHEDULE_SUCCESS';
export const GET_GUEST_NETWORK_SCHEDULE_FAIL = 'GET_GUEST_NETWORK_SCHEDULE_FAIL';
export const UPDATE_GUEST_NETWORK_SCHEDULE = 'UPDATE_GUEST_NETWORK_SCHEDULE';
export const UPDATE_GUEST_NETWORK_SCHEDULE_LOADING = 'UPDATE_GUEST_NETWORK_SCHEDULE_LOADING';
export const UPDATE_GUEST_NETWORK_SCHEDULE_SUCCESS = 'UPDATE_GUEST_NETWORK_SCHEDULE_SUCCESS';
export const UPDATE_GUEST_NETWORK_SCHEDULE_FAIL = 'UPDATE_GUEST_NETWORK_SCHEDULE_FAIL';
export const CLEAR_GUEST_NETWORK_ERROR = 'CLEAR_GUEST_NETWORK_ERROR';
export const STOP_GUEST_SESSION_POLLING = 'STOP_GUEST_SESSION_POLLING';
export const SET_GUEST_SESSION_POLLING = 'SET_GUEST_SESSION_POLLING';

// Networks
export const GET_NETWORKS = 'GET_NETWORKS';
export const GET_NETWORKS_LOADING = 'GET_NETWORKS_LOADING';
export const GET_NETWORKS_SUCCESS = 'GET_NETWORKS_SUCCESS';
export const GET_NETWORKS_FAIL = 'GET_NETWORKS_FAIL';
export const SET_SELECTED_NETWORK = 'SET_SELECTED_NETWORK';
export const GET_NETWORK_DEVICES = 'GET_NETWORK_DEVICES';
export const GET_NETWORK_DEVICES_LOADING = 'GET_NETWORK_DEVICES_LOADING';
export const GET_NETWORK_DEVICES_SUCCESS = 'GET_NETWORK_DEVICES_SUCCESS';
export const GET_NETWORK_DEVICES_FAIL = 'GET_NETWORK_DEVICES_FAIL';
export const UPDATE_NETWORK = 'UPDATE_NETWORK';
export const UPDATE_NETWORK_LOADING = 'UPDATE_NETWORK_LOADING';
export const UPDATE_NETWORK_SUCCESS = 'UPDATE_NETWORK_SUCCESS';
export const UPDATE_NETWORK_FAIL = 'UPDATE_NETWORK_FAIL';
export const CLEAR_UPDATE_NETWORK_ERROR = 'CLEAR_UPDATE_NETWORK_ERROR';
export const DELETE_NETWORK = 'DELETE_NETWORK';
export const DELETE_NETWORK_LOADING = 'DELETE_NETWORK_LOADING';
export const DELETE_NETWORK_SUCCESS = 'DELETE_NETWORK_SUCCESS';
export const DELETE_NETWORK_FAIL = 'DELETE_NETWORK_FAIL';

// Thread Network
export const GET_NETWORK_THREAD = 'GET_NETWORK_THREAD';
export const GET_NETWORK_THREAD_SUCCESS = 'GET_NETWORK_THREAD_SUCCESS';
export const GET_NETWORK_THREAD_FAIL = 'GET_NETWORK_THREAD_FAIL';
export const GET_NETWORK_THREAD_LOADING = 'GET_NETWORK_THREAD_LOADING';
export const RESET_NETWORK_THREAD_ERROR_SUCCESS = 'RESET_NETWORK_THREAD_ERROR_SUCCESS';
export const GET_THREAD_RADIO_STATUS = 'GET_THREAD_RADIO_STATUS';
export const GET_THREAD_RADIO_STATUS_SUCCESS = 'GET_THREAD_RADIO_STATUS_SUCCESS';
export const GET_THREAD_RADIO_STATUS_FAIL = 'GET_THREAD_RADIO_STATUS_FAIL';
export const GET_THREAD_RADIO_STATUS_LOADING = 'GET_THREAD_RADIO_STATUS_LOADING';
export const TOGGLE_NETWORK_THREAD = 'TOGGLE_NETWORK_THREAD';
export const TOGGLE_NETWORK_THREAD_SUCCESS = 'TOGGLE_NETWORK_THREAD_SUCCESS';
export const TOGGLE_NETWORK_THREAD_FAIL = 'TOGGLE_NETWORK_THREAD_FAIL';
export const TOGGLE_NETWORK_THREAD_LOADING = 'TOGGLE_NETWORK_THREAD_LOADING';
export const THREAD_INITIAL_LOAD_FAILED = 'THREAD_INITIAL_LOAD_FAILED';

// Cellular Backup
export const INIT_CELLULAR = 'INIT_CELLULAR';
export const SET_CELLULAR = 'SET_CELLULAR';
export const FETCH_CELLULAR_FAILED = 'FETCH_CELLULAR_FAILED';

// Static IP Config
export const INIT_STATIC_IP_CONFIG = 'INIT_STATIC_IP_CONFIG';
export const SET_STATIC_IP_CONFIG = 'SET_STATIC_IP_CONFIG';
export const FETCH_STATIC_IP_CONFIG_FAILED = 'FETCH_STATIC_IP_CONFIG_FAILED';

// Broadcast Settings
export const INIT_BROADCAST_SETTINGS = 'INIT_BROADCAST_SETTINGS';
export const SET_BROADCAST_SETTINGS = 'SET_BROADCAST_SETTINGS';
export const FETCH_BROADCAST_SETTINGS_FAILED = 'FETCH_BROADCAST_SETTINGS_FAILED';

// Network Device Pause
export const GET_NETWORK_DEVICE_PAUSE_STATE = 'GET_NETWORK_DEVICE_PAUSE_STATE';
export const GET_NETWORK_DEVICE_PAUSE_STATE_LOADING = 'GET_NETWORK_DEVICE_PAUSE_STATE_LOADING';
export const GET_NETWORK_DEVICE_PAUSE_STATE_SUCCESS = 'GET_NETWORK_DEVICE_PAUSE_STATE_SUCCESS';
export const GET_NETWORK_DEVICE_PAUSE_STATE_FAIL = 'GET_NETWORK_DEVICE_PAUSE_STATE_FAIL';
export const CLEAR_DEVICE_PAUSE_STATE_ERROR = 'CLEAR_DEVICE_PAUSE_STATE_ERROR';
export const CLEAR_PAUSE_NETWORK_DEVICE_ERROR = 'CLEAR_PAUSE_NETWORK_DEVICE_ERROR';
export const PAUSE_NETWORK_DEVICE = 'PAUSE_NETWORK_DEVICE';
export const PAUSE_NETWORK_DEVICE_LOADING = 'PAUSE_NETWORK_DEVICE_LOADING';
export const PAUSE_NETWORK_DEVICE_SUCCESS = 'PAUSE_NETWORK_DEVICE_SUCCESS';
export const PAUSE_NETWORK_DEVICE_FAIL = 'PAUSE_NETWORK_DEVICE_FAIL';
export const UNPAUSE_NETWORK_DEVICE = 'UNPAUSE_NETWORK_DEVICE';
export const UNPAUSE_NETWORK_DEVICE_SUCCESS = 'UNPAUSE_NETWORK_DEVICE_SUCCESS';
export const UNPAUSE_NETWORK_DEVICE_FAIL = 'UNPAUSE_NETWORK_DEVICE_FAIL';
